import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect } from 'react';
import { Typography, Grid } from '@material-ui/core';
import CustomTable from 'components/CustomTable';
import CustomButton from 'components/CustomInput/Button';
import { UPDATE_SITE_INFO_INSIDE_VALIDITY } from 'store/key';
import { getSystemMessage } from 'store/system/systemMessageReducer';
import { checkTableColumnCompleted } from 'utility/formValidate';
import { declareStudentKey } from 'constants/globalEnum';

const useStyles = makeStyles((theme) => ({
    formTitleWeight: {
        fontWeight: 'bold',
    },
    item: {
        paddingBottom: theme.spacing(1),
    },
}));

export default function DeclarationAndEndorsementFormLayout(props) {
    const classes = useStyles();
    const {
        siteInfoId,
        formId,
        disableOnPermission,
        deleteRow,
        siteInfoInsideValid,
        declareStudentColumns,
        declareStudentRows,
        dispatch,
        handleEditClick,
        handleAddClick,
        student,
        disableOldDataDelete,
        applicationCreateDtm,
        mapShowRow,
        isHighlight,
    } = props;

    /** check declaration's table rows of auto-filled for completeness when click "Save" button start */
    const [declareStudentValid, setDeclareStudentValid] = useState(true);
    useEffect(() => {
        const valid = student ? checkTableColumnCompleted(declareStudentRows) : true;
        setDeclareStudentValid(valid);
        // eslint-disable-next-line
    }, [declareStudentRows, student]);

    useEffect(() => {
        dispatch({
            type: UPDATE_SITE_INFO_INSIDE_VALIDITY,
            payload: {
                applicationFormId: formId,
                siteInfoId: siteInfoId,
                formKey: 'declareStudentValid',
                isValid: declareStudentValid,
            },
        });
        // eslint-disable-next-line
    }, [declareStudentValid]);
    /** check declaration's table rows of auto-filled for completeness when click "Save" button end */

    return student ? (
        <Grid container className={classes.item}>
            <Grid
                className={classes.formTitleWeight}
                style={{ margin: '8px 0', background: isHighlight('declareStudent') ? 'yellow' : 'initial' }}
            >
                For Student Project
            </Grid>
            <Grid container>
                <CustomButton
                    disableOnPermission={disableOnPermission}
                    style={{ margin: '0 8px 8px 0' }}
                    onClick={() => handleAddClick(declareStudentKey)}
                >
                    Add
                </CustomButton>
                {siteInfoInsideValid?.declareStudentValid === false && (
                    <Grid container>
                        <Typography color="error">
                            {getSystemMessage('checkCompleteness', [
                                '"table column: Title, Position, Responsibility for Clinical oversight"',
                            ])}
                        </Typography>
                    </Grid>
                )}
                <CustomTable
                    disableOnPermission={disableOnPermission}
                    isEditAllow={true}
                    onEdit={(row) => handleEditClick(row, declareStudentKey)}
                    isDeleteAllow={true}
                    onDelete={(row) => deleteRow(row, declareStudentKey)}
                    columns={declareStudentColumns}
                    rows={mapShowRow?.(declareStudentRows, declareStudentKey)}
                    allowResize
                    isDesc={true}
                    defaultSortKey={'role'}
                    fullWidthTable={false}
                    disableOldDataDelete={disableOldDataDelete}
                    applicationCreateDtm={applicationCreateDtm}
                />
            </Grid>
        </Grid>
    ) : null;
}
